import React, { createContext, useContext, useState, useCallback } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("bf_lang") || "pt");

  const changeLang = useCallback((l) => {
    setLang(l);
    localStorage.setItem("bf_lang", l);
  }, []);

  const t = useCallback(
    (key) => {
      const dict = translations[lang] || translations.pt;
      return dict[key] !== undefined ? dict[key] : key;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, changeLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
